<template>
  <aside
    id="sac-sidebar"
    :class="[showSidebar ? 'show' : '']"
  >
    <div class="sidebar-content">
      <fragment v-if="!showPartnerFilter">
        <div class="grid-column jc-b ai-c">
          <div class="sac__font-16 bold">
            Filter By Partner
          </div>
          <button
            v-if="isSmacAdmin"
            id="filter-btn"
            type="button"
            @click.stop="showPartnerFilter = !showPartnerFilter"
          >
            <img
              src="../../assets/img/general/svg/filter-icon.svg"
              alt="x"
              class="img-size-20"
            >
          </button>
        </div>
        <div v-if="activeTags.length && isSmacAdmin" class="tag-container margin-top-16">
          <div
            v-for="(tag, idx) in activeTags"
            :key="idx"
            class="filter-tag"
          >
            <span>{{ tag.value }}</span>
            <img
              src="../../assets/img/general/svg/x-white.svg"
              alt="x"
              class="delete-btn"
              @click.stop="removePartnerFilter(tag.key, tag.value)"
              @keydown="removePartnerFilter(tag.key, tag.value)"
            >
          </div>
        </div>
        <div class="grid-row margin-top-16">
          <SACSearch
            :search="search"
            :height="40"
            @input="(value) => changeSearch(value)"
          />
          <div v-if="!partnerList.length" class="sac__font-16 semi-bold center margin-top-16">
            No partner found.
          </div>
          <div v-else class="grid-row margin-top-16 scrollable">
            <div
              v-for="(item, idx) in partnerList"
              :key="idx"
              :ref="`scrollable-item-${item.value}`"
              :class="['row-item', item.value === adminFilter.corpId ? 'active' : '']"
              @click="changeFilter(item)"
              @keydown="changeFilter(item)"
            >
              <div>
                {{ item.label }}
              </div>
              <img
                v-if="item.value === adminFilter.corpId"
                src="../../assets/img/general/svg/check-white.svg"
                alt="back"
                class="back-arrow"
              >
            </div>
          </div>
        </div>
      </fragment>
      <PartnerFilter
        v-else
        :showPartnerFilter="showPartnerFilter"
        :close="() => showPartnerFilter = false"
      />
    </div>
  </aside>
</template>

<script>
import SACSearch from '@shared/components/sac/SACSearch.vue';
import PartnerFilter from '@shared/components/admin/PartnerFilter.vue';
import adminMixin from '@shared/mixins/adminMixin';

export default {
  name: 'AdminFilter',
  components: {
    PartnerFilter,
    SACSearch,
  },
  mixins: [adminMixin],
  data() {
    return {
      search: '',
      showPartnerFilter: false,
      partnerFilter: {},
    };
  },
  computed: {
    partnerList() {
      const list = this.allBranches(true);
      if (this.search) {
        return list.filter((branch) => {
          const text = this.search.toLowerCase();
          const { label } = branch;
          return label.toLowerCase().includes(text);
        });
      }
      return list;
    },
    showSidebar: {
      get() {
        return this.showRightSidebar;
      },
      set(value) {
        this.$store.dispatch('changeLeadValue', {
          field: 'showRightSidebar',
          value,
        });
      },
    },
    activeTags() {
      const activeTags = [];
      if (this.adminFilter.partner.psm) {
        activeTags.push({ key: 'psm', value: this.adminFilter.partner.psmName });
      }
      if (this.adminFilter.partner.type.length) {
        const typeList = this.adminFilter.partner.type;
        typeList.forEach((type) => {
          activeTags.push({ key: 'type', value: type });
        });
      }
      if (this.adminFilter.partner.engagementLevel) {
        activeTags.push({ key: 'engagementLevel', value: this.adminFilter.partner.engagementLevel });
      }
      if (this.adminFilter.partner.status) {
        activeTags.push({ key: 'status', value: this.adminFilter.partner.status });
      }
      return activeTags;
    },
  },
  mounted() {
    document.querySelector(':not(#sac-sidebar)').addEventListener('click', this.closeOnClick);
  },
  destroyed() {
    document.querySelector(':not(#sac-sidebar)').removeEventListener('click', this.closeOnClick);
  },
  methods: {
    changeFilter(item) {
      this.$store.dispatch('changeAdminValues', [{
        field: 'adminFilter',
        value: {
          ...this.adminFilter,
          corpId: item.value,
          corpName: item.label,
        },
      }]);
      localStorage.setItem('adminFilter', JSON.stringify({
        ...this.adminFilter,
        corpId: item.value,
        corpName: item.label,
      }));
      this.$root.$emit('updateAdminFilter');
    },
    removePartnerFilter(key, value) {
      const partnerFilter = { ...this.adminFilter.partner };
      if (key === 'psm') {
        partnerFilter.psm = '';
      }
      if (key === 'engagementLevel') {
        partnerFilter.engagementLevel = '';
      }
      if (key === 'status') {
        partnerFilter.status = '';
      }
      if (key === 'type') {
        partnerFilter.type = partnerFilter.type.filter((item) => item !== value);
      }
      this.$store.dispatch('changeAdminValues', [{
        field: 'adminFilter',
        value: {
          ...this.adminFilter,
          partner: { ...partnerFilter },
        },
      }]);
      localStorage.setItem('adminFilter', JSON.stringify({
        ...this.adminFilter,
        partner: { ...partnerFilter },
      }));
    },
    changeSearch(search) {
      this.search = search;
    },
    closeOnClick(e) {
      if (!e.target.closest('#sac-sidebar')
        && !e.target.closest('#partner-filter')
        && !e.target.closest('#admin-partner')
        && this.showSidebar) {
        this.$store.dispatch('changeAdminValues', [{
          field: 'showRightSidebar',
          value: false,
        }]);
        this.showPartnerFilter = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
#sac-sidebar {
  opacity: 0;
  display: flex;
  flex-direction: column;
  background-color: $WHITE;
  width: 0;
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  transition: 0.3s ease-in-out;
  z-index: 999;
  justify-content: space-between;
  box-shadow: -2px 0 15px -2px rgba(0, 0, 0, 0.3);
  &.show {
    padding: 24px;
    width: 450px;
    opacity: 1;
  }
  .sidebar-content {
    overflow: hidden;
    .row-item {
      padding: 8px 16px;
      cursor: pointer;
      display: grid;
      grid-auto-flow: column;
      justify-content: space-between;
      align-items: center;
      border-radius: 6px;
      &:hover {
        background-color: $NBLUE20;
      }
      &.active {
        background-color: $NBLUE110;
        color: $WHITE;
      }
    }
    .tag-container {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      justify-content: flex-start;
      .filter-tag {
        display: grid;
        grid-auto-flow: column;
        gap: 8px;
        padding: 2px 8px;
        align-items: center;
        background-color: $NBLUE70;
        border-radius: 4px;
        .delete-btn {
          height: 16px;
          width: auto;
          background-color: $NBLUE100;
          border-radius: 50%;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
